import { ACCENT_CYAN, NOPING_GREEN } from '../constants';

export function SmoothLine() {
  return (
    <div className='relative h-32 w-full overflow-hidden'>
      <svg viewBox='0 0 400 120' className='size-full' preserveAspectRatio='none'>
        <defs>
          <linearGradient id='lineGrad' x1='0' y1='0' x2='0' y2='1'>
            <stop offset='0%' stopColor={ACCENT_CYAN} stopOpacity='0.3' />
            <stop offset='100%' stopColor={ACCENT_CYAN} stopOpacity='0' />
          </linearGradient>
        </defs>
        <path d='M0,100 Q50,95 100,90 T200,85 T300,82 T400,80' fill='url(#lineGrad)' stroke='none' />
        <path d='M0,100 Q50,95 100,90 T200,85 T300,82 T400,80' fill='none' stroke={ACCENT_CYAN} strokeWidth='2' className='animate-draw-smooth' />
        <path d='M0,100 Q50,95 100,90 T200,85 T300,82 T400,80' fill='none' stroke={NOPING_GREEN} strokeWidth='1.5' strokeDasharray='4 4' opacity='0.4' />
      </svg>
      <style>{`
        .animate-draw-smooth {
          stroke-dasharray: 800;
          stroke-dashoffset: 800;
          animation: drawSmooth 2s ease-out forwards;
        }
        @keyframes drawSmooth {
          to { stroke-dashoffset: 0; }
        }
      `}</style>
    </div>
  );
}
